import React from 'react';
import botIcon from '../../../_assets/sass/pages/chatbot/logo1.svg';   
import enFlag from '../../../_assets/sass/pages/chatbot/en.svg';  
import saudiFlag from '../../../_assets/sass/pages/chatbot/ar.svg'; 
import kurdishFlag from '../../../_assets/sass/pages/chatbot/kd.svg'; 
import {  useIntl } from "react-intl";

const Languages = (props) => {
    let { incrementPage} = props;
    const intl = useIntl();
    return (<>

      <div className="language-container">
        <img src={botIcon} alt="Bot Icon" className="bot-icon" />
        <h2 className="title">{intl.formatMessage({ id: "CHAT.SELECTLANG" })}</h2>

        <div className="language-options">
            <button className="lang-btn"  onClick={(e) => {
                e.stopPropagation(); 
                incrementPage();
              }}>
            <img src={enFlag} alt="US Flag" />
            <div>
                <strong>English</strong>
                <div className="subtext">English – US</div>
            </div>
            </button>

            <button className="lang-btn">
            <img src={saudiFlag} alt="Saudi Flag" />
            <div>
                <strong>Arabic</strong>
                <div className="subtext">العربية</div>
            </div>
            </button>

            <button className="lang-btn">
            <img src={kurdishFlag} alt="Kurdish Flag" />
            <div>
                <strong>Kurdish (Bahdini)</strong>
                <div className="subtext">کوردی (بادینی)</div>
            </div>
            </button>

            <button className="lang-btn">
            <img src={kurdishFlag} alt="Kurdish Flag" />
            <div>
                <strong>Kurdish (Sorani)</strong>
                <div className="subtext">کوردی (سۆرانی)</div>
            </div>
            </button>
        </div>

        <div className="recent-chats">
            <div className="icon-circle">
            <i className="fa fa-undo"></i>
            </div>
            <div>
            <strong>{intl.formatMessage({ id: "CHAT.REC" })}</strong>
            <div className="subtext">{intl.formatMessage({ id: "CHAT.CHECKRECENT" })}</div>
            <i className="fa fa-chevron-right"></i>
            </div>
        </div>
        </div>



        
        </>
    );
};

export default Languages;